import { render, staticRenderFns } from "./ComboMealsModal.vue?vue&type=template&id=2a133a46&scoped=true"
import script from "./ComboMealsModal.vue?vue&type=script&lang=ts"
export * from "./ComboMealsModal.vue?vue&type=script&lang=ts"
import style0 from "./ComboMealsModal.vue?vue&type=style&index=0&id=2a133a46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a133a46",
  null
  
)

export default component.exports